var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-main"}},[_c('main-menu',{staticClass:"d-print-none"}),_c('main-app-bar',{staticClass:"d-print-none"}),_c('v-main',{staticClass:"main-contenido"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }